import * as React from 'react';
import * as main from "../../styles/main.module.scss";
import * as cost from "./style.module.scss";
import { TaxDeduction } from "../../../../TaxDeduction";
export const Cost = ({ widget, free=false }) => {
  return (
    <section className={cost.cost} id="widget">
      <div className={cost.cost__wrapper}>
        <div className="container">
          <div className={cost.cost__inner}>
            <div className={cost.cost__desc}>
              <span className={cost.cost__subtitle}>
                Онлайн-курс
              </span>
              <h2 className={`${main.mainTitle} ${cost.cost__title}`}>
                ТАЙМ-МЕНЕДЖМЕНТ<br/>и<br/>ПОВЫШЕНИЕ ЭФФЕКТИВНОСТИ
              </h2>
              {
                free ?
                  <div className={cost.cost__newcost}>
                    БЕСПЛАТНО
                  </div>
                  :
                  <>
                    <div className={cost.cost__newcost}>
                      490 ₽
                    </div>
                    <TaxDeduction margin={"30px 0 0"} color={"#F3EAFF"} align={"center"}/>
                  </>
              }
            </div>
            <div className={cost.cost__widget}>
              <div>
                { widget }
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
